import * as React from "react";
import { SVGProps } from "react";

const Singularitynet = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill="none">
      <circle cx={16} cy={16} r={16} fill="#6916ff" />
      <g fill="#fff">
        <path
          fillOpacity={0.5}
          d="M17.144 6.424a.28.28 0 0 1-.081-.363.289.289 0 0 1 .312 0 5.63 5.63 0 0 1 1.875 1.272c.303.281.557.609.75.97.204.368.371.753.5 1.152.123.413.187.842.188 1.272-.063.425-.125 2.485-1.313 3.455a.714.714 0 0 1-.938-.182.627.627 0 0 1-.062-.727A5.047 5.047 0 0 0 18.5 8c-.4-.566-.854-1.093-1.356-1.576zM15.3 25.006c.125.121.125.242.063.303s-.188.121-.25.06a5.63 5.63 0 0 1-1.875-1.272 3.709 3.709 0 0 1-.75-.97 6.463 6.463 0 0 1-.5-1.151 4.482 4.482 0 0 1-.188-1.273c.063-.424.125-2.485 1.313-3.455a.714.714 0 0 1 .937.182.539.539 0 0 1 0 .728 5.047 5.047 0 0 0-.125 5.272c.405.567.866 1.095 1.375 1.576z"
        />
        <path d="M20.694 20.006a5.473 5.473 0 0 0-1.313-3.151 10.816 10.816 0 0 0-2.625-1.94 14.466 14.466 0 0 1-2.375-1.642 4.032 4.032 0 0 1-1.187-2.121 4.243 4.243 0 0 1 .306-2.48 6.692 6.692 0 0 1 1.756-2.242.26.26 0 0 0 .063-.303.242.242 0 0 0-.375-.06 5.577 5.577 0 0 0-2.438 2.06 5.01 5.01 0 0 0-.881 3.273 5.25 5.25 0 0 0 .438 1.697 6 6 0 0 0 1 1.455 10.78 10.78 0 0 0 2.687 1.878c.848.44 1.645.969 2.375 1.576a3.603 3.603 0 0 1 1.188 2.182c.176.879.066 1.79-.313 2.606a6.13 6.13 0 0 1-1.813 2.182.207.207 0 0 0-.063.303c.035.064.1.11.173.121s.149-.01.203-.06a7.801 7.801 0 0 0 2.375-2.122c.62-.958.906-2.084.819-3.212z" />
      </g>
    </g>
  </svg>
);

export default Singularitynet;
